export const parseVerificationErrorCodeMessage = (codes) => {
  if (codes[0] === "invalid_code") {
    return "Invalid verification code";
  } else {
    return null;
  }
};
